export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'

export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST'
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS'
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL'

export const PAYMENT_CHECKOUT_REQUEST = ' PAYMENT_CHECKOUT_REQUEST'
export const PAYMENT_CHECKOUT_SUCCESS = ' PAYMENT_CHECKOUT_SUCCESS'
export const PAYMENT_CHECKOUT_FAIL = 'PAYMENT_CHECKOUT_FAIL'
export const PAYMENT_CHECKOUT_RESET = 'PAYMENT_CHECKOUT_RESET'

export const PAYMENT_VALIDATE_REQUEST = ' PAYMENT_VALIDATE_REQUEST'
export const PAYMENT_VALIDATE_SUCCESS = ' PAYMENT_VALIDATE_SUCCESS'
export const PAYMENT_VALIDATE_FAIL = 'PAYMENT_VALIDATE_FAIL'
export const PAYMENT_VALIDATE_RESET = 'PAYMENT_VALIDATE_RESET'

export const USER_TOUR_SHOW = 'USER_TOUR_SHOW'
export const USER_TOUR_HIDE = 'USER_TOUR_HIDE'

export const ONBOARD_FIRST_STEP_REQUEST = 'ONBOARD_FIRST_STEP_REQUEST'
export const ONBOARD_FIRST_STEP_SUCCESS = 'ONBOARD_FIRST_STEP_SUCCESS'
export const ONBOARD_FIRST_STEP_FAIL = 'ONBOARD_FIRST_STEP_FAIL'

export const ONBOARD_SECOND_STEP_REQUEST = 'ONBOARD_SECOND_STEP_REQUEST'
export const ONBOARD_SECOND_STEP_SUCCESS = 'ONBOARD_SECOND_STEP_SUCCESS'
export const ONBOARD_SECOND_STEP_FAIL = 'ONBOARD_SECOND_STEP_FAIL'

export const ONBOARD_THIRD_STEP_REQUEST = 'ONBOARD_THIRD_STEP_REQUEST'
export const ONBOARD_THIRD_STEP_SUCCESS = 'ONBOARD_THIRD_STEP_SUCCESS'
export const ONBOARD_THIRD_STEP_FAIL = 'ONBOARD_THIRD_STEP_FAIL'

export const ONBOARD_FINAL_REQUEST = 'ONBOARD_FINAL_REQUEST'
export const ONBOARD_FINAL_SUCCESS = 'ONBOARD_FINAL_SUCCESS'
export const ONBOARD_FINAL_FAIL = 'ONBOARD_FINAL_FAIL'